import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/app'
import { getUser, logoutUser } from '../store/slices/auth-slice'
import { ROLES } from '../constants'
import { useNavigate } from 'react-router-dom'

function InstructorPagesProvider({ children }: { children: React.ReactNode }) {
    const [loadPage, setLoadPage] = useState<boolean>(false)
    const user = useAppSelector(getUser)
    const navigate = useNavigate()

    useEffect(() => {
        if (user?.role !== ROLES.INSTRUCTOR) {
            navigate("/")
        }
        setLoadPage(true)
    }, [user])

    return (
        <>
            {loadPage ? <div>{children}</div> : null}
        </>
    )
}

export default InstructorPagesProvider